module.exports = __webpack_public_path__ + "static/media/400070_02.5326bfa4.png";